<div class="tables-service-container">
  <div class="table-service-header"> {{ 'TABLES.TABLES_SERVICES' | fallbackTranslate }}</div>
  <!-- <div class="margin-top-60"></div> -->

  <div class="topnav">
    <div
      (click)="update_activenav('rn')"
      class="nav-items"
      [ngClass]="{ 'nav-active': activeNav === 'rn' }"
    >
      {{ 'TABLES.RECENT_NOTIFICATIONS' | fallbackTranslate }}
    </div>
    <!-- <div
      (click)="update_activenav('ro')"
      class="nav-items"
      [ngClass]="{ 'nav-active': activeNav === 'ro' }"
    >
      RUNNING ORDERS
    </div> -->

    <hr class="hr-line" />
  </div>

  <!-- notification section -->
  <div
    class="my-tables-container ml-25 mr-25"
    *ngIf="
      allNotification.length !== 0 &&
      activeNav === 'rn' &&
      noNotification == false
    "
  >
    <!-- server card container div -->
    <div class="server-cards-container">
      <!-- server card div -->
      <div class="server-card" *ngFor="let notification of allNotification">
        <div
          class="card_upper_container"
          (click)="
            notification.collect_cash
              ? openModal(
                  notification.message_id,
                  notification.order_id,
                  notification.order_ids,
                  notification
                )
              : ''
          "
        >
          <div class="server-card-top">
            <div class="server-card-top-lc">
              <div class="server-card-tno">
                <div class="txt-upper">{{ notification.table_no }}</div>
              </div>
            </div>
            <div class="server-card-top-rc">
              <div class="text-username-notification">
                {{ notification.username | titlecase }}
              </div>
              <div class="floor-paid-row">
                <img
                  [src]="images.ASPECT_RATIO_MATERIAL"
                  alt="aspect-ratio"
                  class="img-20 mr-10"
                  style="vertical-align: middle"
                />
                <div class="text-floorname">
                  {{ notification.floor_name | titlecase }}
                </div>
              </div>
            </div>
            <div class="server-card-top-last">
              <img [src]="images.TIMER" alt="timer" />
              <p class="timer">{{ notification.time_text }}</p>
            </div>
          </div>

          <div
            class="message-area-cash-collect"
            *ngIf="notification.collect_cash"
          >
            <div>
              <img [src]="images.CASH_TABLE_SERVICE" alt="cash-table-icon" />
            </div>
            <div style="margin-left: 10px">
              <div class="cash_total_text">
                <!-- {{Currency}} 1000 -->
              </div>
              <div class="collect_cash_text">
                {{ 'SETTLE_BILL.COLLECT_CASH' | fallbackTranslate }}
              </div>
            </div>
          </div>

          <div
            class="message-area-item-required"
            *ngIf="!notification.collect_cash"
          >
            <div class="text-message">
              {{ notification.message }}
            </div>
            <div
              class="details-holder-grid"
              *ngIf="notification.specifics.length > 0"
            >
              <div
                class="message-details"
                *ngFor="let item of notification.specifics"
              >
                <span *ngIf="item.quantity">{{ item.quantity }} x &nbsp;</span
                ><span>{{ item.subcategory_name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="server-card-bottom c-served text-color-basic"
          (click)="ack_notification(notification.message_id)"
          style="cursor: pointer"
          *ngIf="!notification.collect_cash"
        >
          {{ 'TABLES.MARK_DONE' | fallbackTranslate }}
        </div>
        <div
          class="server-card-bottom c-served text-color-basic"
          (click)="
            openModal(
              notification.message_id,
              notification.order_id,
              notification.order_ids,
              notification
            )
          "
          style="cursor: pointer"
          *ngIf="notification.collect_cash"
        >
          {{ 'GLOBAL.VIEW_DETAILS' | fallbackTranslate }}
        </div>
      </div>
      <!-- ends server card div -->

      <!-- to fill empty space -->
      <!-- <div class="server-card-empty"></div>
      <div class="server-card-empty"></div>
      <div class="server-card-empty"></div>
      <div class="server-card-empty"></div> -->
    </div>

    <!-- ends server card container div -->
  </div>
  <!-- notification section  -->

  <div *ngIf="noNotification">
    <p class="no-request">
      {{ 'SETTLE_BILL.NO_NEW_REQUEST' | fallbackTranslate }}
    </p>
  </div>
</div>
